






import Vue from 'vue';

export default Vue.extend({
  name: "CityHallMain2d",
  data: () => {
    return {};
  },
});
